module.exports = __webpack_public_path__ + "img/wuwow_ty.2caec810.png";